import { buildURI, useFetch } from '@hn-front/utils';
import { ACTIVITY_STREAM_API } from '../../constants/routes';
import { adaptGroupsActivityStreamToClient } from './adapter';
var useFetchGroupsActivityStream = function (groupId, query) {
    return useFetch(buildURI(ACTIVITY_STREAM_API.groupsActivity, {
        pathParams: { groupId: groupId },
        query: {
            school_id: query.schoolId,
            activity_stream_filter: query.period,
            role: query.role,
        },
    }), {
        isCache: false,
        isStale: true,
        adapter: adaptGroupsActivityStreamToClient,
    });
};
export { useFetchGroupsActivityStream };
